import React from 'react';
import DealCard from './DealCard';

const DealsList = ({ deals }) => {
  return (
    <div className="deals-grid">
      {deals.map((deal) => (
        <DealCard deal={deal} key={deal.id} />
      ))}
    </div>
  );
};

export default DealsList;
